<template>
  <div class="containerDiv">
    <PCNavbar selectIndex="telMsg"/>
    <MobileNavBar :currentActive="10"/>
     <!-- 头部banner图片 -->
     <!-- <img class="bannerImgcss0" src="../img3/rencaijiaoliu/rencaizhaopin-bg.png" /> -->
     <img class="bannerImgcss0" src="../assets/bannner/lianxiwomen.png" />

    <!-- 二级菜单切换 -->
    <telMsg />
    
  </div>
</template>

<script>
import API from '@/api/index'

import telMsg from '@/components/telMsg/index.vue'

import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
  
export default {
  components: {
    PCNavbar,
    MobileNavBar,
     
    telMsg
  },
  data() {
    return {
      apitest:API.leftMenuList,
     
    }
  },
  mounted(){
    
  },
  methods:{
    
    
    
  }
 

}
</script>

<style lang="scss" scoped>
.bannerImgcss0{
  width:100%;
  // margin-top:50px;
  height:auto;
}
.containerDiv{
   min-width: 1000px;
  .production_card {
    width: 90vw;
    margin: 0 auto;
    background:#ffffff;
  }
}
.bottom_circle {
  width: 100%;
  text-align: center;
  padding-top: 100px;
  background-image: url(../assets/img/smalldot.png),url(../assets/img/smalldot1.png);
  background-position: 0 0,110% 150%;
  background-repeat: no-repeat;
  background-size: 400px;
  h1 {
    font-size: 40px;
    padding-bottom: 20px;
    @media screen and (max-width: 768px) {
      font-size: 1.15rem;
      width: 60%;
      margin: 0 auto;
    }
  }
  
  .circle_img {
    width: 100%;
    img {
      width: 70%;
      @media screen and (max-width: 768px) {
        width: 100%;
        margin: 20PX 0;
      }
    }
  }

 
}
</style>